module.exports = __webpack_public_path__ + "media/images/icons/SVG/066-f6f73c080f8e8ce4c0f431a77e5ecd18.svg";